import styled from 'styled-components';
import {device} from 'styled/device';
import {CustomIcon} from '@guestapp/ui';
import {ShareRegistrationLinkButton as ShareRegistrationLinkButtonComponent} from 'components/ShareRegistrationLinkButton';
import {MainButton} from 'styled/common';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  padding: 0 20px;

  @media (min-width: ${device.mobileL}) {
    width: 500px;
  }
  @media (min-width: ${device.laptopM}) {
    width: 856px;
  }
`;

export const StyledIcon = styled(CustomIcon)`
  margin: 0 auto 25px;
  display: block;
  width: 200px;
  height: 200px;
`;

export const Title = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.36px;
  margin-bottom: 8px;
  font-family: ${props => props.theme.fonts.fontFamily.titles.font_name};
  color: ${props => props.theme.colors.branding.fontPrimary};
`;

export const SubTitle = styled.div`
  font-style: normal;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  margin: 0 auto 72px;
  color: ${props => props.theme.colors.branding.fontSecondary};

  @media (min-width: ${device.tablet}) {
    width: 100%;
    text-align: center;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    max-width: 320px;
    margin: 0 auto 48px;
  }
`;

export const ShareRegistrationLinkButton = styled(ShareRegistrationLinkButtonComponent)`
  margin-bottom: 60px;
  margin-top: 32px;
`;

export const RegisterButton = styled(MainButton)`
  margin-top: 10px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 290px;
  margin-top: 24px;
`;

export const GuestPanelContainer = styled.div`
  margin-bottom: 16px;
  padding: 0;
  width: 280px;
  background: rgb(255, 255, 255);
  border-radius: 12px;
  opacity: 1;
  transition: opacity 0.3s ease-in-out 0s;
  box-shadow: rgba(0, 0, 0, 0.07) 0 3px 6px 0;
  overflow: hidden;

  & .guests-panel__item {
    border-radius: 0;
  }

  @media (min-width: ${device.mobileM}) {
    width: 325px;
  }

  @media (min-width: ${device.tablet}) {
    width: 416px;
  }
`;

export const PmsGuestPanelContainer = styled.div`
  margin-bottom: 48px;
  margin-top: 56px;

  @media (min-width: ${device.tablet}) {
    width: 100%;
    margin-top: 0;
  }

  @media (min-width: ${device.laptop}) {
    margin-top: 0;
  }
`;
